// src/components/Cart.js
import { useCart } from "../CartContext";
import { Link } from "react-router-dom";

export default function Cart({ lang }) {
  const { cart, removeFromCart, clearCart } = useCart();

  const total = cart.reduce((sum, p) => {
  const numericPrice =
    parseFloat(
      String(p.price)
        .replace(/[^\d.,]/g, "")
        .replace(",", ".")
    ) || 0;

  return sum + numericPrice * (p.qty || 1);
}, 0);

  if (cart.length === 0) {
    return (
      <section className="section">
        <h2>{lang === "pl" ? "Koszyk" : "Cart"}</h2>
        <p>{lang === "pl" ? "Koszyk jest pusty." : "Your cart is empty."}</p>
      </section>
    );
  }

  return (
    <section className="section">
      <h2>{lang === "pl" ? "Koszyk" : "Cart"}</h2>

      <div className="cart-list">
        {cart.map((item) => (
          <div key={item.id} className="cart-item">
            <div>
              <strong>{lang === "pl" ? item.name_pl : item.name_en}</strong>
              <div>
             {item.qty} × {parseFloat(String(item.price).replace(/[^\d.,]/g, '').replace(',', '.'))} zł
              </div>
            </div>

            <button
              className="admin-small-btn"
              onClick={() => removeFromCart(item.id)}
            >
              {lang === "pl" ? "Usuń" : "Remove"}
            </button>
          </div>
        ))}
      </div>

      <h3 style={{ marginTop: "20px" }}>
        {lang === "pl" ? "Razem:" : "Total:"} {total} zł
      </h3>

      <div style={{ marginTop: "20px", display: "flex", gap: "10px" }}>
        <button className="btn-ghost" onClick={clearCart}>
          {lang === "pl" ? "Wyczyść koszyk" : "Clear cart"}
        </button>

        <Link to="/checkout">
          <button className="btn-primary">
            {lang === "pl" ? "Przejdź do zamówienia" : "Proceed to checkout"}
          </button>
        </Link>
      </div>
    </section>
  );
}
